import { Button, Modal } from "@payping/web-components";
import { loggedOut } from "@payping/redux/actions";
import { buildUrl } from "@payping/utilities-shared/url";
import * as Sentry from "@sentry/react";
import { useEffect, useState } from "react";
import { useAsyncFn } from "react-use";
import { useNavigate } from "react-router";

import { removeLottieLoading, useAppDispatch, useAppSelector, useAppTranslation } from "@/utils";
import { URLS } from "@payping/utilities-shared/consts";

const LogoutPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const token = useAppSelector((state) => state.auth.token);
  const [tmpToken, setTmpToken] = useState<string>(token);
  const [loading, setLoading] = useState<boolean>(false);
  const { t } = useAppTranslation();

  // token may arrive after store rehydration; snapshot it during render instead of a cascading effect render
  if (token && token !== tmpToken) {
    setTmpToken(token);
  }

  useEffect(() => {
    removeLottieLoading();
  }, []);

  const [, handleLogout] = useAsyncFn(async () => {
    setLoading(true);
    // to erase crisp and oidc from browser storage
    localStorage.clear();
    sessionStorage.clear();

    // remove sentry data
    Sentry.getCurrentScope().setUser(null);

    // remove token from redux
    dispatch(loggedOut());

    // redirect to logout page
    // TODO: this method should be changed in backend to be a POST method, then, it should be moved to api package
    window.location.assign(
      buildUrl(URLS.AUTH_URL, `/Account/FrontLogout?clientid=payping-BNPLClient&token=${tmpToken}`).toString(),
    );
  });

  return (
    <div>
      <Modal
        open
        title={t("logoutModal.title")}
        footer={
          <>
            <Button type={"default"} onClick={() => navigate(-1)} loading={loading}>
              {t("common.no")}
            </Button>
            <Button type={"primary"} danger onClick={handleLogout} loading={loading}>
              {t("common.yes")}
            </Button>
          </>
        }
      >
        {t("logoutModal.text")}
      </Modal>
    </div>
  );
};

// Inject the Params provided by React Router into connected components
export default LogoutPage;
